import React from 'react';
import PropTypes from 'prop-types';

import SelectableRow from 'components/selectable_record_table/selectable_row';
import CallContactLink from 'components/click_to_call/call_contact_link';
import CustomFieldValue, { isCustomFieldSlug } from './custom_field_value';
import { isPresent, valueOrPlaceholder } from 'helpers/string_helpers';
import { rowFormatConfig } from 'helpers/comps/comp_info_mappings';

const renderContactLink = (contact, link, key) => (
  <td className="hidden-xs hidden-sm" key={key}>
    <a className="contact-link" href={link}>
      {contact}
    </a>
  </td>
);

const renderLeaseCells = ({ currentColumns, currentUser, edgeCrm, lease }) => {
  const url = edgeCrm ? lease.path : lease.propertyUrl;
  const propertyName = (
    <td key="property-name">
      <a href={url}>
        <strong>{lease.displayName}</strong>
      </a>
    </td>
  );

  const leaseUrl = `${url}${edgeCrm ? '' : `&leaseId=${lease.id}`}`;
  const suite = (
    <td key={'name'}>
      <a href={leaseUrl}>
        {lease.suite}
      </a>
    </td>
  );

  const additionalCells = currentColumns.map((column) => {
    if (isCustomFieldSlug(column)) {
      return <CustomFieldValue comp={lease} key={column} slug={column} />;
    } else if (column === 'ownerPhoneNumber') {
      return (
        <td className="hidden-xs hidden-sm" key={column}>
          <CallContactLink
            phone={lease.ownerPhoneNumber}
            phoneNormalized={lease.ownerPhoneNormalized}
            targetName={lease.ownerName}
            user={currentUser}
          />
        </td>
      );
    } else if (column === 'tenantString' && isPresent(lease[column])) {
      return renderContactLink(lease[column], lease.tenantUrl, column);
    } else if (column === 'ownerName' && isPresent(lease[column])) {
      return renderContactLink(lease[column], lease.ownerUrl, column);
    } else if (column === 'tenantContactString' && isPresent(lease[column])) {
      return renderContactLink(lease[column], lease.tenantContactUrl, column);
    } else if (column === 'landlordString' && isPresent(lease[column])) {
      return renderContactLink(lease[column], lease.landlordUrl, column);
    } else if (rowFormatConfig[column] && lease[column]) {
      return (
        <td className="hidden-xs hidden-sm" key={column}>
          {rowFormatConfig[column].format(lease[column])}
        </td>
      );
    } else {
      return (
        <td className="hidden-xs hidden-sm" key={column}>
          {valueOrPlaceholder(lease[column])}
        </td>
      );
    }
  });
  return [propertyName, suite, ...additionalCells];
};

const LeaseRow = ({ currentColumns, currentUser, edgeCrm, lease, selected, onSelect }) => {
  return (
    <SelectableRow
      selected={selected}
      onChange={() => {
        onSelect && onSelect(lease);
      }}
    >
      {renderLeaseCells({ currentColumns, currentUser, edgeCrm, lease })}
    </SelectableRow>
  );
};

LeaseRow.propTypes = {
  currentColumns: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired,
  edgeCrm: PropTypes.bool,
  lease: PropTypes.object.isRequired,
  selected: PropTypes.bool,
  onSelect: PropTypes.func
};

export default LeaseRow;
